import { cx } from './cx.js';

/**
 * The room, dimmed but still there.
 *
 * Two things open over a live table — the settings drawer and the sheet that
 * hands a finished grid over — and both wanted the same thing: the felt behind
 * them quieted, not replaced, because in both cases what is behind is what the
 * panel in front is about. They were written twice and came out at two
 * different strengths, 50% with a 2px blur and 62% with a 3px one, which is a
 * difference nobody chose.
 *
 * One strength, the lighter one, because "still legible" is the whole point of
 * a scrim rather than a cover. A screen that genuinely needs the room gone
 * paints `bg-ground` over it instead.
 */

export interface ScrimProps {
  /**
   * Dismiss on a press, the way tapping the felt beside an open drawer would.
   * A scrim carries no role, so this is never the only way out: the panel in
   * front of it has a button that assistive tech is told about.
   */
  readonly onClick?: (() => void) | undefined;
  /** Positioning and stacking only. */
  readonly className?: string | undefined;
}

const SCRIM = 'absolute inset-0 bg-ink/55 scrim-entry motion-reduce:animate-none';

export function Scrim({ onClick, className }: ScrimProps): React.JSX.Element {
  return <div className={cx(SCRIM, className)} aria-hidden="true" onClick={onClick} />;
}
